import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    marginLeft: 20,
    marginTop: 10,
    marginBottom: 10,
  },
  gridMargin: {
    marginTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
  },
  toggleButtonMargin: {
    marginRight: 15,
    marginLeft: 15,
  },
  filterBackground: {
    background: '#ECEAEA',
  },
  totalFilter: {
    color: '#64b5f6',
  },
  btnGeneratePreview: {
    textTransform: 'none',
    margin: theme.spacing(4, 4, 0, 0),
  },
  startPosition: {
    margin: theme.spacing(4, 0, 0, 4),
    fontSize: 18,
  },
}))
export default useStyles
